import { useEffect, useState } from 'react'
import { RhyBusPageHeader } from '@rhybus/header'
import { RhyBusCalendarInnerview } from '@rhybus/calendar'
import { getCalendarEventItems, CalendarEventItem } from '../../services/contentManagement'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'

export default function Calendar() {
    const [calendarEvents, setCalendarEvents] = useState<CalendarEventItem[]>([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        getCalendarEventItems().then(setCalendarEvents).finally(() => setIsLoading(false))
    }, [])

    return (
        <main id="main-content">
            {isLoading && <PageOverlay />}
            <RhyBusPageHeader pageTitle={'Event Calendar'} pageHeaderIcon="icon-rb-calendar" />
            <div className='rb-calendar-page'>
                <RhyBusCalendarInnerview calendarEvents={calendarEvents} />
            </div>
        </main>
    )
}